<template>
  <u-popup
    v-model="iframeDialogShow"
    class="iframe_dialog"
    mode="center"
    :width="deviceInfo.isMobile ? '90%' : '962px'"
    :height="deviceInfo.isMobile ? '80%' : '90%'"
    border-radius="50"
    :mask-close-able="false"
  >
    <view class="flex flex-col h-full">
      <!-- 关闭按钮 -->
      <view class="close_btn" @click="close">
        <view class="close_btn_img iconfont icon-close text-18"></view>
      </view>
      <h2 class="title">运行 HTML</h2>
      <view class="line"></view>
      <view class="flex-center flex-1 relative p-20">
        <iframe
          :id="iframeId"
          :src="iframeSrc"
          style="display: block; height: 100%; width: 100%; border: none"
          sandbox="allow-scripts allow-same-origin"
        ></iframe>
      </view>
    </view>
  </u-popup>
</template>

<script>
import useDeviceEnv from "@/views/Home/useData/useDeviceEnv/useDeviceEnv";
const { deviceInfo } = useDeviceEnv();
export default {
  components: {},
  props: {
    htmlContent: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      iframeSrc: `${window.location.origin}/#/pages/user-content/user-content`,
      iframeId: "iframe_id" + Math.random(),
      iframeDialogShow: false,
      deviceInfo,
    };
  },
  methods: {
    show() {
      this.iframeDialogShow = true;
      setTimeout(() => {
        const iframe = document.getElementById(this.iframeId);
        if (iframe && this.htmlContent) {
          iframe.addEventListener("load", () => {
            console.log("post message to iframe");
            iframe.contentWindow.postMessage(
              {
                type: "user-html",
                payload: { html: this.htmlContent },
              },
              "*"
            );
          });
        } else {
          uni.showToast({
            title: "运行失败，请稍后重试",
            icon: "none",
          });
          setTimeout(this.close, 200);
        }
      }, 200);
    },
    close() {
      this.iframeDialogShow = false;
    },
  },
};
</script>

<style lang="scss" scoped>
.iframe_dialog {
  font-size: 14px;
}
.title {
  position: absolute;
  top: 15px;
  left: 20px;
}
.line {
  border: 1px solid #eeeeee;
  margin: 5px 0;
}
.close_btn {
  /* position: absolute;
  top: 10px;
  // left: 50;
  right: 20px; */
  cursor: pointer;

  display: flex;
  justify-content: flex-end;
  margin: 12px 20px 0 0;
  align-items: center;
  height: 35px;
  .close_btn_img {
    /* width: 30px;
    height: 30px; */
  }
}
</style>
